<template>
  <div class="commission-manager">
    <el-form :inline="true">
      <el-form-item>
        <toolbar
          :buttonList="buttonList"
          @callFunction="callFunction"
        ></toolbar>
      </el-form-item>
    </el-form>

    <!-- 阶梯提成配置列表 - 适配新字段 -->
    <el-table
      :data="commissionList"
      border
      stripe
      @current-change="selectCurrentRow"
      style="width: 100%; margin-top: 20px"
      row-key="id"
    >
      <!-- 提成编号 -->
      <el-table-column prop="number" label="提成编号" width="120" />
      <!-- 阶梯名称 -->
      <el-table-column prop="ladderName" label="阶梯名称" width="" />
      <!-- 阶梯最小值(包含) -->
      <el-table-column
        prop="ladderStart"
        label="阶梯最小值（包含）"
        width="150"
      />
      <!-- 阶梯最大值(包含) -->
      <el-table-column
        prop="ladderEnd"
        label="阶梯最大值（包含）"
        width="180"
      />
      <!-- 提成比例 -->
      <el-table-column prop="commissionRatio" label="提成比例" width="120">
        <template #default="scope">
          <span>{{scope.row.commissionRatio}}%</span>
        </template>
      </el-table-column>
      <!-- 有效周期(年) -->
      <el-table-column
        prop="validPeriod"
        label="有效周期（单位年）"
        width="160"
      >
        <template #default="scope">
          {{ scope.row.validPeriod || "-" }}
        </template>
      </el-table-column>
      <!-- 创建人 -->
      <el-table-column prop="createUserName" label="创建人" width="120" />
      <!-- 创建时间 -->
      <el-table-column prop="createTime" label="创建时间" width="200" />
      <!-- 是否启用 - 标签样式匹配截图 -->
      <el-table-column prop="isEnable" label="是否启用" width="120">
        <template #default="scope">
          <el-tag type="success" v-if="scope.row.isEnable">已启用</el-tag>
          <el-tag type="info" v-else>未启用</el-tag>
        </template>
      </el-table-column>
      <!-- 修改人 -->
      <el-table-column prop="updateUserName" label="修改人" width="120" />
      <!-- 修改时间 -->
      <el-table-column prop="updateTime" label="修改时间" width="200" />
      <!-- 操作列 -->
      <el-table-column label="操作" width="140">
        <template #default="scope">
          <el-button type="text" @click="handleEdit2(scope.row)"
            >编辑</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <!-- 新增/编辑弹窗 - 适配新字段 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="40%"
      destroy-on-close
      :close-on-click-modal="false"
    >
      <el-form
        :model="formData"
        :rules="formRules"
        ref="formRef"
        label-width="220px"
      >
        <!--				<el-form-item label="主键ID" prop="id">-->
        <!--					<el-input-->
        <!--							v-model.number="formData.id"-->
        <!--							placeholder="自动生成"-->
        <!--							style="width: 60%"-->
        <!--							disabled-->
        <!--					/>-->
        <!--				</el-form-item>-->

        <el-form-item label="提成编号" prop="number">
          <el-input
            v-model="formData.number"
            placeholder="请输入提成编号"
            style="width: 80%"
          />
        </el-form-item>

        <el-form-item label="阶梯名称" prop="ladderName">
          <el-input
            v-model="formData.ladderName"
            placeholder="请输入阶梯名称，如：第一阶梯"
            style="width: 80%"
          />
        </el-form-item>

        <el-form-item label="阶梯最小值（包含）" prop="ladderStart">
          <el-input
            v-model.number="formData.ladderStart"
            placeholder="请输入区间最小值"
            style="width: 80%"
          />
        </el-form-item>

        <el-form-item label="阶梯最大值（包含）" prop="ladderEnd">
          <el-input
            v-model.number="formData.ladderEnd"
            placeholder="请输入区间最大值"
            style="width: 80%"
          />
        </el-form-item>

        <el-form-item label="提成系数" prop="commissionRatio">
          <el-input
            v-model="formData.commissionRatio"
            placeholder="请输入提成比例百分比，如：10 20"
            style="width: 80%"
          />
        </el-form-item>

        <el-form-item label="有效周期（单位年）" prop="validPeriod">
          <el-input
            v-model.number="formData.validPeriod"
            placeholder="请输入有效周期，如：1"
            style="width: 80%"
          />
        </el-form-item>

        <el-form-item label="是否启用" prop="isEnable">
          <el-switch
            v-model="formData.isEnable"
            active-text="已启用"
            inactive-text="未启用"
            :active-value="true"
            :inactive-value="false"
          />
        </el-form-item>

        <!--				<el-form-item label="生效时间" prop="enableTime">-->
        <!--					<el-date-picker-->
        <!--							v-model="formData.enableTime"-->
        <!--							type="datetime"-->
        <!--							placeholder="选择生效时间"-->
        <!--							style="width: 60%"-->
        <!--							value-format="yyyy-MM-dd HH:mm:ss"-->
        <!--					/>-->
        <!--				</el-form-item>-->
      </el-form>
      <template #footer>
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSave">保存</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
// 提成配置接口，替换为你实际的阶梯提成接口
import {
  getCommissionBasisList,
  addCarouselInformation,
  updateCarouselInformation,
  deleteCarouselInformation,
  getCommissionAnchorLadderBasisList,
  addCommissionAnchorLadderBasis,
  updateCommissionAnchorLadderBasis,
} from "../../api/api";
import { useEnterSearch, removeEnterSearch } from "../../../util/enterSearch";
export default {
  components: { Toolbar },
  name: "CommissionLevelManager",
  data() {
    return {
      buttonList: [],
      // 阶梯提成列表数据
      commissionList: [],
      // 弹窗配置
      dialogVisible: false,
      dialogTitle: "",
      formRef: null,
      // 表单数据 - 适配新字段
      formData: {
        // 主键ID
        id: undefined,
        // 提成编号
        number: undefined,
        // 阶梯名称
        ladderName: undefined,
        // 阶梯最小值（包含）
        ladderStart: undefined,
        // 阶梯最大值（包含）
        ladderEnd: undefined,
        // 提成比例
        commissionRatio: undefined,
        // 有效周期（单位年）
        validPeriod: 1,
        // 是否启用
        isEnable: true,
        // 生效/其他字段
        enableTime: undefined,
        createTime: undefined,
        updateTime: undefined,
        createUserId: undefined,
        createUserName: undefined,
        updateUserId: undefined,
        updateUserName: undefined,
      },
      // 表单校验规则 - 适配新字段
      formRules: {
        number: [
          { required: true, message: "请输入提成编号", trigger: "blur" },
        ],
        ladderName: [
          { required: true, message: "请输入阶梯名称", trigger: "blur" },
        ],
        ladderStart: [
          { required: true, message: "请输入阶梯最小值", trigger: "blur" },
          { type: "number", message: "阶梯最小值必须为数字", trigger: "blur" },
        ],
        ladderEnd: [
          { required: true, message: "请输入阶梯最大值", trigger: "blur" },
          { type: "number", message: "阶梯最大值必须为数字", trigger: "blur" },
        ],
        commissionRatio: [
          { required: true, message: "请输入提成比例", trigger: "blur" },
        ],
        validPeriod: [
          { required: true, message: "请输入有效周期", trigger: "blur" },
          { type: "number", message: "有效周期必须为数字", trigger: "blur" },
        ],
      },
      // 表格选中行数据
      needData: null,
      // 查询条件
      filters: {
        ladderName: undefined,
      },
    };
  },

  beforeDestroy() {
    // 移除全局回车监听
    removeEnterSearch();
  },
  methods: {
    // 表格当前行选中
    selectCurrentRow(val) {
      this.needData = val;
    },

    // 获取阶梯提成列表数据
    getListData() {
      this.getList();
    },

    // 获取列表接口请求
    getList() {
      const params = {};
      // 调用后端阶梯提成列表接口
      getCommissionAnchorLadderBasisList(params)
        .then((res) => {
          // 适配后端返回结构，直接赋值列表
          this.commissionList = res.data?.response || [];
        })
        .catch(() => {
          this.$message.error("阶梯提成列表加载失败");
        });
    },

    // 工具栏按钮调用
    callFunction(item) {
      this[item.func]();
    },

    // 新增阶梯提成
    handleAdd() {
      this.dialogTitle = "新增阶梯提成配置";
      this.resetForm();
      this.dialogVisible = true;
    },
    handleEdit() {
      console.log("handleEdit");
      if (!this.needData) {
        this.$message.error("请选择要编辑的数据！");
        return;
      }
      this.dialogTitle = "编辑阶梯提成配置";
      // 深拷贝赋值，避免双向绑定污染原数据
      this.formData = JSON.parse(JSON.stringify(this.needData));
      this.dialogVisible = true;
    },

    // 编辑阶梯提成
    handleEdit2(row) {
      console.log("handleEdit2");
      if (!row) {
        this.$message.error("请选择要编辑的数据！");
        return;
      }
      this.dialogTitle = "编辑阶梯提成配置";
      // 深拷贝赋值，避免双向绑定污染原数据
      this.formData = JSON.parse(JSON.stringify(row));
      this.dialogVisible = true;
    },

    // 删除阶梯提成
    handleDel() {
      if (!this.needData) {
        this.$message.error("请选择要删除的数据！");
        return;
      }
      this.$confirm("此操作将删除该阶梯提成配置, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // 调用删除接口
          deleteCarouselInformation({ id: this.needData.id })
            .then((res) => {
              if (res.data.success) {
                this.$message.success("删除成功");
                this.getList();
              } else {
                this.$message.error(res.data.message || "删除失败");
              }
            })
            .catch(() => {
              this.$message.error("删除接口请求失败");
            });
        })
        .catch(() => {
          this.$message.info("已取消删除");
        });
    },

    // 重置表单数据
    resetForm() {
      this.formData = {
        id: undefined,
        number: undefined,
        ladderName: undefined,
        ladderStart: undefined,
        ladderEnd: undefined,
        commissionRatio: undefined,
        validPeriod: undefined,
        isEnable: true,
        enableTime: undefined,
        createTime: undefined,
        updateTime: undefined,
        updateUserId: undefined,
        updateUserName: undefined,
      };
      // 清空校验状态
      if (this.$refs.formRef) {
        this.$refs.formRef.resetFields();
      }
    },

    // 保存新增/编辑
    handleSave() {
      this.$refs.formRef.validate((valid) => {
        if (!valid) return;
        // 编辑保存
        if (this.formData.id) {
          updateCommissionAnchorLadderBasis(this.formData)
            .then((res) => {
              if (res.data.success) {
                this.$message.success("修改成功");
                this.getList();
                this.dialogVisible = false;
              } else {
                this.$message.error(res.data.message || "修改失败");
              }
            })
            .catch(() => {
              this.$message.error("修改接口请求失败");
            });
        } else {
          // 新增保存
          addCommissionAnchorLadderBasis(this.formData)
            .then((res) => {
              if (res.data.success) {
                this.$message.success("新增成功");
                this.getList();
                this.dialogVisible = false;
              } else {
                this.$message.error(res.data.message || "新增失败");
              }
            })
            .catch(() => {
              this.$message.error("新增接口请求失败");
            });
        }
      });
    },
  },

  mounted() {
    useEnterSearch(() => {
      this.getListData();
    });
    // 初始化权限按钮
    const routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
    // 加载列表数据
    this.getList();
  },
};
</script>

<style scoped>
.commission-manager {
  padding: 20px;
  box-sizing: border-box;
}
/* 禁用文本域拖拽 */
::v-deep .el-textarea__inner {
  resize: none;
}
/* 表格内容居中美化 */
::v-deep .el-table__cell {
  text-align: center;
}
::v-deep .el-table th.el-table__cell {
  text-align: center;
  background-color: #fafafa;
}
</style>